import ConflictsTooltip from './ConflictsTooltip'
import PublishButton from './PublishButton'
import PublishModal from './PublishModal'
import usePublishShifts from './usePublishShifts'

const Publish = () => {
  const { submitting, showPublishModal, onConfirm, togglePublishModal } = usePublishShifts()

  const onCloseModal = () => togglePublishModal(false)

  return (
    <>
      {showPublishModal && (
        <PublishModal onClose={onCloseModal} onConfirm={onConfirm} submitting={submitting} />
      )}
      <ConflictsTooltip>
        <PublishButton onClick={togglePublishModal} />
      </ConflictsTooltip>
    </>
  )
}

export default Publish
